import { Mail, Phone, MapPin } from "lucide-react";
import { Eyebrow, Lines } from "./Motion";
import { QuoteForm } from "./QuoteForm";
import { CONTACT } from "@/lib/site";

export const Contact = () => (
  <section id="quote" data-testid="section-quote" className="relative bg-[#0A0A0A] px-5 py-28 md:px-10 md:py-40">
    <div className="mx-auto grid max-w-[1500px] gap-16 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Eyebrow>Free estimate</Eyebrow>
        <h2 className="mt-6 font-display text-5xl font-extrabold leading-[0.95] tracking-tighter text-neutral-50 md:text-7xl">
          <Lines lines={["Let's build", <span key="d" className="font-serif font-normal italic text-neutral-400">what's next.</span>]} />
        </h2>
        <p className="mt-8 max-w-md text-neutral-400">Tell us a little about your deck, porch, siding or exterior project. We'll follow up within one business day to schedule a free site walk.</p>
        <div className="mt-12 space-y-5 border-t border-white/[0.08] pt-8">
          <a data-testid="contact-phone-link" href={CONTACT.phoneHref} className="group flex items-center gap-4 text-neutral-200 transition-colors hover:text-white">
            <Phone className="h-4 w-4 text-white" /><span className="font-display text-2xl font-bold tracking-tight">{CONTACT.phone}</span>
          </a>
          <a data-testid="contact-email-link" href={`mailto:${CONTACT.email}`} className="flex items-center gap-4 text-neutral-300 transition-colors hover:text-white">
            <Mail className="h-4 w-4 text-white" />{CONTACT.email}
          </a>
          <div data-testid="contact-region" className="flex items-center gap-4 text-neutral-300">
            <MapPin className="h-4 w-4 text-white" />{CONTACT.region}: Johnson City, Kingsport, Bristol & surrounding areas
          </div>
        </div>
      </div>
      <div className="lg:col-span-7">
        <QuoteForm />
      </div>
    </div>
  </section>
);
